import { combineReducers } from 'redux';
import ptc from './ptc';

const biReducer = combineReducers({
    ptc,
});

export default biReducer;
